import { motion } from "framer-motion";
import { fadeIn } from "../styles/variants";
import { useEffect } from 'react';

const Contact = ({activeComp, setActiveComp, pageHeight = 100, refs}) => {
  const observerMargin = Math.floor(pageHeight / 2);

  useEffect(() => {
    const observerConfig = {
      rootMargin: `-${
        pageHeight % 2 === 0 ? observerMargin - 1 : observerMargin
      }px 0px -${observerMargin}px 0px`,
    };
    const handleIntersection = function(entries) {
      entries.forEach((entry) => {
        if (entry.target.id !== activeComp && entry.isIntersecting) {
          setActiveComp(entry.target.id);
        }
      });
    };
    const observer = new IntersectionObserver(
      handleIntersection,
      observerConfig
    );
    observer.observe(refs['contact'].current);
    return () => observer.disconnect(); // Clenaup the observer if component unmount.
  }, [
    activeComp,
    setActiveComp,
    observerMargin,
    refs,
    pageHeight
  ]);

  return (
    <section id="contact" ref={refs['contact']} className="section h-[100vh] pb-24 lg:p-0">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row">
          {/*text*/}
          <motion.div 
            variants={fadeIn('right', 0.3)} 
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex justify-center md:justify-end items-center"
          >
            <div>
              <h4 className="text-xl uppercase text-accent font-medium mb-2 tracking-wide text-center md:text-left">
                Get in touch
              </h4>
              <h2 className="text-[45px] lg:text-[90px] leading-none mb-12 text-center md:text-left">
                Let's work <br/> together!
              </h2>
            </div>
          </motion.div>
          <motion.div 
            variants={fadeIn('left', 0.3)} 
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex justify-center items-center"
          >
            <a href="mailto:zalas.patrycja@gmail.com">
              <button className='btn h-[80px] px-10 text-lg'>Contact me</button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;